<template>
  <!-- 案件詳細 -->
  <div id="HolterRequestDetail">
    <div  id="item-contens" style="text-align:right;">
        <b-button v-if="requestCancel" class="is-primary" style="margin-right:3%;" @click="cancelReasonInputModalActive=true">検査をキャンセル</b-button>
    </div>
    <div id="item-contens">
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">基本情報</span>
        <table v-if="data.delivaryTarget=='home'">
          <tr><th>医療機関名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.hospitalName}}</td></tr>
          <tr><th>医師名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.doctorName}}</td></tr>
          <tr><th>事務担当者名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.clerkName}}</td></tr>
          <template v-if="data.isDealer">
            <tr><th>医療機関メールアドレス</th><td><b-checkbox style="width: 26px" value="true" disabled v-model="data.isResultMailSend"></b-checkbox>解析結果のダウンロードURLを医療機関にメールで通知する。</td></tr>
            <tr v-if="data.isResultMailSend"><th></th><td>{{data.hospitalMail}}</td></tr>
          </template>
          <tr><th>機種</th><td>{{data.model | getNameFilter(models)}}</td></tr>
          <tr><th>検査期間</th><td>{{data.inspectionPeriod | getNameFilter(inspectionPeriodList)}}</td></tr>
          <tr v-if="!isHideAnalysisOptions"><th>解析オプション</th><td>{{data.analysisOption | getNameFilter(analysisOptionList)}}</td></tr>
          <tr v-if="data.judgmentFlag"><th>判定医</th><td><b-checkbox style="width:26px;" value="true" disabled v-model="data.judgment"/>前回と違う判定医に依頼する。</td></tr>
          <tr v-if="showDepositInfoFlag"><th>配送先</th><td>患者宅に配達する</td></tr>
          <tr><th>WP300同梱の有無</th><td><span v-if="data.hstRequestFlag">有</span><span v-else>無</span></td></tr>
          <tr><th>納品書</th><td><span v-if="data.deliverySlip">必要</span><span v-else>不要</span></td>
          <tr><th>デモ</th><td :class="{ 'strong': data.demo && $route.params.callSearchFlag }"><b-checkbox style="width:26px;" value="true" disabled v-model="data.demo"/>デモ(トライアル)</td></tr>
        </table>
        <table v-else>
          <tr><th>医療機関名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.hospitalName}}</td></tr>
          <tr><th>医師名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.doctorName}}</td></tr>
          <tr><th>事務担当者名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.clerkName}}</td></tr>
          <template v-if="data.isDealer">
            <tr><th>医療機関メールアドレス</th><td><b-checkbox style="width: 26px" value="true" disabled v-model="data.isResultMailSend"></b-checkbox>解析結果のダウンロードURLを医療機関にメールで通知する。</td></tr>
            <tr v-if="data.isResultMailSend"><th></th><td>{{data.hospitalMail}}</td></tr>
          </template>
          <tr><th>機種</th><td>{{data.model | getNameFilter(models)}}</td></tr>
          <tr><th>検査期間</th><td>{{data.inspectionPeriod | getNameFilter(inspectionPeriodList)}}</td></tr>
          <tr v-if="!isHideAnalysisOptions"><th>解析オプション</th><td>{{data.analysisOption | getNameFilter(analysisOptionList)}}</td></tr>
          <tr v-if="data.judgmentFlag"><th>判定医</th><td><b-checkbox style="width:26px;" value="true" disabled v-model="data.judgment"/>前回と違う判定医に依頼する。</td></tr>
          <tr v-if="showDepositInfoFlag"><th>配送先</th><td>医療機関に配達する</td></tr>
          <tr><th>WP300同梱の有無</th><td><span v-if="data.hstRequestFlag">有</span><span v-else>無</span></td></tr>
          <tr v-if="data.delivaryTarget=='hospital' && !atLaunchHidden.hiddenFlag"><th>リードワイヤーアダプター</th><td><span v-if="data.leadWireAdapter">必要</span><span v-else>不要</span></td></tr>
          <tr><th>郵便番号</th><td>{{data.zip}}</td></tr>
          <tr><th>住所</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.address}}</td></tr>
          <tr><th>住所（丁目、番地）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.address1}}</td></tr>
          <tr><th>住所（建物名、号室）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.address2}}</td></tr>
          <tr><th>宛名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.receiverName}}</td></tr>
          <tr><th>連絡先(電話番号)</th><td>{{data.phoneNumber}}</td></tr>
          <tr><th>配達希望時間帯</th><td>{{data.desiredDeliveryTimeZone | getNameFilter(timeZone)}}</td></tr>
          <tr><th>納品書</th><td><span v-if="data.deliverySlip">必要</span><span v-else>不要</span></td>
          <tr><th>デモ</th><td :class="{ 'strong': data.demo && $route.params.callSearchFlag }"><b-checkbox style="width:26px;" value="true" disabled v-model="data.demo"/>デモ(トライアル)</td></tr>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-for="(patient, index) in data.patientsData" :key="index">
        <span v-if="data.patientsData.length>1" style="font-size:20px;">患者情報{{index+1}}</span>
        <span v-else style="font-size:20px;">患者情報</span>
        <table v-if="data.delivaryTarget=='home'" class="">
          <tr><th>診察券ID（患者ID）</th><td>{{patient.patientId}}</td></tr>
          <tr><th>患者名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.patientFamilyName+" "+patient.patientFirstName}}</td></tr>
          <tr><th>患者名（カナ）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.patientFamilyNameKana+" "+patient.patientFirstNameKana}}</td></tr>
          <tr><th>性別</th><td>{{patient.gender}}</td></tr>
          <tr><th>生年月日</th><td>{{patient.birthday | formatDate()}}<span v-if="patient.birthday" style="margin-left:10px;">{{patient.japaneseCalendar}}</span></td></tr>
          <tr><th>年齢</th><td>{{patient.age}}</td></tr>
          <tr><th>検査目的</th><td>{{patient.inspectionPurpose | getNameFilter(inspectionPurposeList)}}</td></tr>
          <tr><th>基礎疾患・合併症</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.underlyingDisease}}</td></tr>
          <tr><th>投薬状況</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.dosingStatus}}</td></tr>
          <tr><th>主訴</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.chiefComplaint}}</td></tr>
          <tr><th>ペースメーカー</th><td><span v-if="patient.pacemaker == 1">有り</span><span v-else>無し</span></td></tr>
          <tr><th>次回受診日</th><td>{{patient.nextDate | formatDate()}}</td></tr>
          <template v-if="showDepositInfoFlag" >
            <tr><th>郵便番号</th><td>{{patient.zip}}</td></tr>
            <tr><th>住所</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.address}}</td></tr>
            <tr><th>住所（丁目、番地）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.address1}}</td></tr>
            <tr><th>住所（建物名、号室）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.address2}}</td></tr>
            <tr><th>宛名</th><td>{{patient.receiverName}}</td></tr>
          </template>
          <tr><th>連絡先（自宅または携帯）</th><td>{{patient.phoneNumber}}</td></tr>
          <tr v-if="showDepositInfoFlag"><th>配達希望時間帯</th><td>{{patient.desiredDeliveryTimeZone | getNameFilter(timeZone)}}</td></tr>
          <tr><th style="vertical-align:top;">備考、その他、注意事項</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{patient.memo}}</div></td></tr>
        </table>
        <table  v-else>
          <tr><th>診察券ID（患者ID）</th><td>{{patient.patientId}}</td></tr>
          <tr><th>患者名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.patientFamilyName+" "+patient.patientFirstName}}</td></tr>
          <tr><th>患者名（カナ）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.patientFamilyNameKana+" "+patient.patientFirstNameKana}}</td></tr>
          <tr><th>性別</th><td>{{patient.gender}}</td></tr>
          <tr><th>生年月日</th><td>{{patient.birthday | formatDate()}}</td></tr>
          <tr><th>年齢</th><td>{{patient.age}}</td></tr>
          <tr><th>検査目的</th><td>{{patient.inspectionPurpose | getNameFilter(inspectionPurposeList)}}</td></tr>
          <tr><th>基礎疾患・合併症</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.underlyingDisease}}</td></tr>
          <tr><th>投薬状況</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.dosingStatus}}</td></tr>
          <tr><th>主訴</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.chiefComplaint}}</td></tr>
          <tr v-if="patient.pacemaker=='1'"><th>ペースメーカー</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">有り</td></tr>
          <tr v-if="patient.pacemaker=='2'"><th>ペースメーカー</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">無し</td></tr>
          <tr><th>次回受診日</th><td>{{patient.nextDate | formatDate()}}</td></tr>
          <tr><th style="vertical-align:top;">備考、その他、注意事項</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{patient.memo}}</div></td></tr>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">配送情報</span>
        <table>
          <tr v-if="data.hstRequestFlag"><th colspan="2">【{{data.model | getNameFilter(models)}}】と【簡易検査】ウォッチパット 300</th></tr>
          <tr v-if="!data.hstRequestFlag"><th colspan="2">【{{data.model | getNameFilter(models)}}】</th></tr>
          <tr><th>出荷日</th><td>{{data.shippingDate | formatDate()}}</td></tr>
          <tr><th>返却日</th><td>{{data.returnDate | formatDate()}}</td></tr>
          <tr v-if="data.invoiceNumber || data.paymentNumber"><th>送り状番号</th><td>{{data.invoiceNumber}}</td></tr>
          <tr v-if="data.invoiceNumber || data.paymentNumber"><th>着払い番号</th><td>{{data.paymentNumber}}</td></tr>
          <tr><th style="vertical-align:top;">備考、その他、注意事項</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.memo}}</div></td></tr>
        </table>
      </div>
      <div v-if="depositMachineFlag" class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">院内貸出機能</span>
        <table>
          <tr><th>契約院内貸出機台数</th><td>{{data.depositMachineRentalNumber}}台</td></tr>
        </table>
          <b-button v-if="!depositMachineCancelNoDispFlag" class="backButton-marginl is-primary" @click="cancelReasonInputModalActiveDeposit=true">院内貸出解除</b-button>
      </div>
      <ReExaminationDetailPart :detailData="data"/>
      <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
        <reasonInputModal  v-on:setReason="cancel" v-bind:title="'検査キャンセル(キャンセル理由入力)'"></reasonInputModal>
      </b-modal>
      <b-modal :active.sync="cancelReasonInputModalActiveDeposit" has-modal-card>
        <reasonInputModal  v-on:setReason="reasonInputdDepositMachine" v-bind:title="'院内貸出解除(院内貸出解除理由を入力)'"></reasonInputModal>
      </b-modal>
      <CancelDetailPart :detailData="data"/>
    </div>
  </div>
</template>

<script>
import {choicesType} from "@/components/mock/base/const.js";
import {atLaunchHidden} from "@/components/mock/base/const.js";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";
import ReExaminationDetailPart from "./components/ReExaminationDetailPart.vue"
import CancelDetailPart from "./components/CancelDetailPart.vue"

export default {
  name: "HolterRequestDetail",
  props: ["data","requestCancel","depositMachineFlag","depositMachineCancelNoDispFlag","isHideAnalysisOptions"],
  methods: {
    cancel: function(cancelReason) {
      this.$emit('cancel', "Holter", cancelReason);
      this.$parent.close();
    },
    reasonInputdDepositMachine: function(reason) {
      this.cancelReason = reason
      var excuteApi = this.setHolterReceptionInspectionDepositMachineCanceldPOST;
      var successCallBack = this.setHolterReceptionInspectionDepositMachineCanceldPOSTSuccess;
      var errorCallBack = this.setHolterReceptionInspectionDepositMachineCanceldPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHolterReceptionInspectionDepositMachineCanceldPOST: function(client) {
      return client.apis.internalHolter.setHolterReceptionInspectionDepositMachineCanceldPOST({
        body:{
          receptionNo:this.data.receptionNo,
          reason:this.cancelReason,
          version:this.data.version,
        }
      });
    },
    setHolterReceptionInspectionDepositMachineCanceldPOSTSuccess: function(result) {
      // メッセージ表示
      this.cancelReason = ""
      this.showSuccess(result);
      this.$parent.back();
    },
    setHolterReceptionInspectionDepositMachineCanceldPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    }
  },
  data() {
    let models = this.getChoiceList(choicesType.holterKind, true);
    let timeZone = this.getChoiceList(choicesType.deliveryTime, true);
    let attachedWaveform =  this.getChoiceList(choicesType.attachedWaveform, true);
    let inspectionPurposeList = this.getChoiceList(choicesType.holterInspectionPurpose, true);
    let analysisOptionList = this.getChoiceList(choicesType.holterAnalysisOp, true);
    let inspectionPeriodList = this.getChoiceList(choicesType.holterInspectionPeriod, true);
    let depositMachineFlag = depositMachineFlag;
    let showDepositInfoFlag = true;
    if(this.data.hasOwnProperty('depositMachineFlag')){
      showDepositInfoFlag = !this.data.depositMachineFlag;
    } else if(this.data.hasOwnProperty('depo')){
      showDepositInfoFlag = !this.data.depo;
    }

    for(var i=0; i<this.data.patientsData.length; i++){
      if(this.data.patientsData[i].birthday){
        const date = new Date(this.data.patientsData[i].birthday);
        const options = {era: 'long'};
        this.data.patientsData[i]["japaneseCalendar"]  = "【"+this.getJapaneseCalendar(date)+"】"
      }
    }
    return {
      models: models,
      timeZone: timeZone,
      attachedWaveform: attachedWaveform,
      inspectionPurposeList: inspectionPurposeList,
      analysisOptionList: analysisOptionList,
      inspectionPeriodList: inspectionPeriodList,
      atLaunchHidden: atLaunchHidden,
      cancelReasonInputModalActive:false,
      cancelReasonInputModalActiveDeposit:false,
      showDepositInfoFlag:showDepositInfoFlag
    };
  },
  filters: {
    formatDate: function(val){
      if(!val) return ""
      return val.replace(/-/g, "/")
    },
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    reasonInputModal:reasonInputModal,
    ReExaminationDetailPart,
    CancelDetailPart
  },
  mounted: function() {}
};
</script>
<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}
.strong {
  font-size: 18px !important;
  font-weight: bold;
  color : red;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/common/HolterRequestDetail.vue